import React from 'react';

const IconYoutube: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.377 7.61133C22.459 9.0879 22.5 10.5508 22.5 12C22.5 13.4492 22.459 14.9121 22.377 16.3887C22.377 17.3184 22.083 18.1045 21.4951 18.7471C20.9072 19.3897 20.1895 19.7109 19.3418 19.7109C17.2363 19.8203 14.7891 19.875 12 19.875C9.21092 19.875 6.76368 19.8203 4.6582 19.7109C3.81054 19.7109 3.09278 19.3897 2.50488 18.7471C1.91699 18.1045 1.62305 17.3184 1.62305 16.3887C1.54102 14.9121 1.5 13.4492 1.5 12C1.5 11.043 1.55469 9.58009 1.66406 7.61133C1.66406 6.68164 1.95117 5.89551 2.52539 5.25293C3.09961 4.61035 3.81054 4.28906 4.6582 4.28906C6.65431 4.17969 8.9785 4.125 11.6309 4.125H12H12.3691C15.0215 4.125 17.3457 4.17969 19.3418 4.28906C20.1895 4.28906 20.9072 4.61035 21.4951 5.25293C22.083 5.89551 22.377 6.68164 22.377 7.61133ZM9.99023 16.0195L15.9375 12L9.99023 7.93945V16.0195Z"
      fill="currentColor"
    />
  </svg>
);

export default IconYoutube;
